import classNames from 'classnames';
import React from 'react';

type Props = {
  className?: string,
  checked: boolean,
  id: string,
  label: React.ReactNode,
  toolTip?: string,
  disabled?: boolean,
  radioButton?: boolean,

  onChange: React.ChangeEventHandler<HTMLInputElement>
};

class CheckBox extends React.PureComponent<Props> {
  renderLabel (): JSX.Element {
    const { id, label, toolTip } = this.props;

    const hasLabel: boolean = label != null && label !== '' && label !== 1;

    if (toolTip != null && toolTip !== '') {
      return <label className={hasLabel ? undefined : 'esko_checkboxlabelempty'} htmlFor={id} title={toolTip}>{label}</label>;
    } else {
      return <label className={hasLabel ? undefined : 'esko_checkboxlabelempty'} htmlFor={id}>{label}</label>;
    }
  }

  override render (): React.ReactNode {
    const {
      id,
      disabled,
      radioButton,
      className,
      checked,
      onChange
    } = this.props;

    return (
      <div className={classNames('esko_checkbox', {disabled: disabled}, className)}>
        <input id={id}
          type={radioButton ? 'radio' : 'checkbox'}
          checked={checked}
          onChange={onChange}
          disabled={disabled} />
        {this.renderLabel()}
      </div>
    );
  }
}

export default CheckBox;
